import { render, staticRenderFns } from "./document-developer.vue?vue&type=template&id=47b346ab&scoped=true&"
import script from "./document-developer.vue?vue&type=script&lang=js&"
export * from "./document-developer.vue?vue&type=script&lang=js&"
import style0 from "./document-developer.vue?vue&type=style&index=0&id=47b346ab&lang=scss&scoped=true&"
import style1 from "./document-developer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b346ab",
  null
  
)

export default component.exports